import { render, staticRenderFns } from "./Revenue.container.vue?vue&type=template&id=4b8999d8&"
import script from "./Revenue.container.vue?vue&type=script&lang=ts&"
export * from "./Revenue.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports